"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireDefault(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

require("./styles");

var _classnames = _interopRequireDefault(require("classnames"));

var _universe = _interopRequireDefault(require("../../assets/universe.svg"));

var _x = _interopRequireDefault(require("../../assets/icons/x.svg"));

var _userMenu = _interopRequireDefault(require("./user-menu"));

var _reactResponsive = _interopRequireDefault(require("react-responsive"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _typeof(obj) { if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; var ownKeys = Object.keys(source); if (typeof Object.getOwnPropertySymbols === 'function') { ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function (sym) { return Object.getOwnPropertyDescriptor(source, sym).enumerable; })); } ownKeys.forEach(function (key) { _defineProperty(target, key, source[key]); }); } return target; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }

function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } return _assertThisInitialized(self); }

function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }

function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); if (superClass) _setPrototypeOf(subClass, superClass); }

function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }

var UserDrawer,
    boundMethodCheck = function boundMethodCheck(instance, Constructor) {
  if (!(instance instanceof Constructor)) {
    throw new Error('Bound instance method accessed before binding');
  }
};

var _default = UserDrawer = function () {
  var UserDrawer =
  /*#__PURE__*/
  function (_React$Component) {
    _inherits(UserDrawer, _React$Component);

    function UserDrawer() {
      var _this;

      _classCallCheck(this, UserDrawer);

      _this = _possibleConstructorReturn(this, _getPrototypeOf(UserDrawer).apply(this, arguments));
      _this.onClose = _this.onClose.bind(_assertThisInitialized(_this));
      return _this;
    }

    _createClass(UserDrawer, [{
      key: "onClose",
      value: function onClose() {
        boundMethodCheck(this, UserDrawer);
        return this.props.onClose();
      }
    }, {
      key: "componentWillReceiveProps",
      value: function componentWillReceiveProps(newProps) {
        return this.setState(_objectSpread({}, newProps));
      }
    }, {
      key: "render",
      value: function render() {
        var props;
        props = this.props;
        return _react.default.createElement("div", {
          className: "UserDrawer"
        }, _react.default.createElement("div", {
          className: (0, _classnames.default)('overlay', {
            open: this.props.open
          }),
          onClick: this.onClose
        }), _react.default.createElement("div", {
          className: (0, _classnames.default)('drawer', {
            open: this.props.open
          }, this.props.side)
        }, _react.default.createElement("header", null, _react.default.createElement(_universe.default, {
          className: "logo"
        }), _react.default.createElement(_x.default, {
          className: "close-button",
          onClick: this.onClose
        })), _react.default.createElement(_userMenu.default, props)));
      }
    }]);

    return UserDrawer;
  }(_react.default.Component);

  ;
  UserDrawer.propTypes = {
    open: _propTypes.default.bool,
    side: _propTypes.default.oneOf(['left', 'right']),
    user: _propTypes.default.object,
    onNavigate: _propTypes.default.func,
    onClose: _propTypes.default.func.isRequired
  };
  UserDrawer.defaultProps = {
    open: false,
    side: 'right'
  };
  return UserDrawer;
}.call(void 0);

exports.default = _default;